import { ZoomIn } from 'lucide-react';
import ResponsiveImage from '@/components/ResponsiveImage';
import chargerGalleryImages, { chargerImageUrl } from '@/components/charger/chargerGalleryImages';
import '@/components/charger/ChargerGallery.css';

export default function ChargerCardMedia({ charger, en = false, onOpen }) {
  const images = chargerGalleryImages(charger, en);
  const cover = images[0];
  return <button type="button" className="charger-card-media" onClick={onOpen} aria-haspopup="dialog" aria-label={en ? `View photos of ${charger.name}` : `Se billeder af ${charger.name}`}>
    {cover && <ResponsiveImage src={cover.url} alt={cover.alt} width={700} height={525} widths={[400, 700, 1000]} sizes="(max-width: 767px) 100vw, (max-width: 1023px) 50vw, 33vw" />}
    <span className="charger-card-media-label"><ZoomIn className="w-4 h-4" aria-hidden="true" />{en ? `View ${images.length} photos` : `Se ${images.length} billeder`}</span>
  </button>;
}